import { useTranslation } from 'react-i18next';
import { NavigationPageItem } from '@cbridge-utils/navigation';
import { RouteSegments, useClientPageVisibility } from '@cbridge-packages/routing-client-admin';

export const useDashboardNavigationItems = () => {
  const { t } = useTranslation();
  const { isQuotesDashboardVisible, isTradingVisible } = useClientPageVisibility();

  const items: NavigationPageItem[] = [
    // Quotes view — gated by the quotesDashboard feature
    ...(isQuotesDashboardVisible ? [{
      title: t('text:dashboard.quotesView.title'),
      segment: RouteSegments.Dashboards.Prices,
      pattern: `${RouteSegments.Dashboards.Prices}{/*path}`,
    }] : []),
    {
      title: t('text:navigation.dashboard.connectionStatus'),
      segment: RouteSegments.Dashboards.ConnectionStatus,
    },
    // Exposure is trading data: hidden without the basicBridge feature
    ...(isTradingVisible ? [{
      title: t('text:navigation.dashboard.exposure'),
      segment: RouteSegments.Dashboards.Exposure,
      disabledTooltip: t('text:common.misc.comingSoon'),
    }] : []),
    {
      title: t('text:navigation.dashboard.performanceMetrics'),
      segment: RouteSegments.Dashboards.PerformanceMetrics,
    },
    /*{
      title: t('text:navigation.dashboard.businessMetrics'),
      segment: RouteSegments.Dashboards.BusinessMetrics,
      disabled: true,
      disabledTooltip: t('text:common.misc.comingSoon'),
    },
    {
      title: t('text:navigation.dashboard.billingMetrics'),
      segment: RouteSegments.Dashboards.BillingMetrics,
      disabled: true,
      disabledTooltip: t('text:common.misc.comingSoon'),
    },*/
    {
      title: t('text:navigation.dashboard.alerts'),
      segment: RouteSegments.Dashboards.Alerts,
    },
  ];

  return items;
};
